import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-upload-icon',
    templateUrl: './upload-icon.component.html',
    styleUrls: ['./upload-icon.component.scss']
})
export class UploadIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 32;
    }
}
